<template>
  <div class="simulator-page">
    <transition mode="out-in" name="fade">
      <router-view @show-exit-modal="showExitModal"/>
    </transition>

    <div v-show="exitModalShow" class="simulator-modal show" id="simulator-error3">
      <div class="simulator-modal__body error">
        <div class="simulator-modal__title">Вы уверены, что хотите выйти?</div>
        <div class="simulator-modal__text">Экзамен будет завершен.<br> Результаты не сохранятся.</div>

        <div class="simulator-row-btn flex flex-justify-sb">
          <a href="/" class="simulator-button light">Выйти</a>
          <a @click="hideExitMNodal" class="simulator-button">Отмена</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Layout',
    data() {
      return {
        exitModalShow: false,
      };
    },
    methods: {
      showExitModal() {
        this.exitModalShow = true;
      },
      hideExitMNodal() {
        this.exitModalShow = false;
      },
    },
  };
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>
